import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Component, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { NgIf } from '../../../../node_modules/@angular/common';

import { CustomerHttpService } from '@services/customer-http/customer-http.service';
import { PersonalDetailsModel } from '@services/customer-http/models/customer.model';

import { SessionExpiresComponent } from '@components/session-expires/session-expires.component';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tax-years-list',
  imports: [NgIf],
  templateUrl: './tax-years-list.component.html',
  styleUrl: './tax-years-list.component.scss',
})
export class TaxYearsListComponent implements OnInit {
  selectedYear: number | null = null;
  private subscription = new Subscription();
  is2025Available: boolean = true;

  constructor(private customerHttpService: CustomerHttpService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.customerHttpService.getPersonalDetails().subscribe({
        next: (answer: PersonalDetailsModel) => {
          this.is2025Available = true;
        },
        error: (errorResponse: HttpErrorResponse) => {
          if (errorResponse.status === 460) {
            this.is2025Available = false;
          }
          console.log(errorResponse);
        },
      })
    );
  }

  onContinue(): void {
    if (!this.selectedYear) {
      return;
    }

    window.open(environment.auPairURLS[this.selectedYear!], '_self');
  }
}
